module.exports = __webpack_public_path__ + "static/img/brees-2012-slide-7.adade4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-slide-7.jpg
// module id = XFZj
// module chunks = 1